import { useEffect, useState } from 'react';
import { CourierObj } from '../fetch/fetchInbound';
import { fetchCourierArray } from '../fetch/fetchCourierArray';

export function useGetCourierArray(): {
  courierArray: CourierObj[];
  isLoading: boolean;
} {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [courierArray, setCourierArray] = useState<CourierObj[]>(null);

  useEffect(() => {
    const fetchShopArrayMethod = async () => {
      const courierArrayResult = await fetchCourierArray();

      setCourierArray(courierArrayResult);
      setIsLoading(false);
    };

    fetchShopArrayMethod();
  }, [setIsLoading]);

  return { courierArray, isLoading };
}
